import forEachElement from '../../elements/forEachElement';
import getFieldsByName from '../elements/getFieldsByName';
import { selectors } from '../elements/constants';
import getForm from '../elements/getForm';
import * as i18n from './i18n';

export default function interpolatePanelText(panel) {
  const form = getForm(panel);

  forEachElement(panel.querySelectorAll(selectors.interpolation), span => {
    const variable = span.dataset.var;
    const field = getFieldsByName(form, variable)[0]?.value;
    span.innerHTML = i18n.t(form, variable) || field;
  });
}
